import http from 'http'
import server from 'src/utils/server'

export const getUserPermissions = (id) => {
  return http.get(server.url_to('users/' + id + '/permissions'))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}



// WEBPACK FOOTER //
// ./src/app/components/shareds/authorized-link/services.js